import { loadTemporaryAccessToken, setTemporaryAccessToken } from "utils/storage";

import { ITokenResults } from "./types";
import ClientTokenService from "./ClientTokenService";

let token: string | null = loadTemporaryAccessToken();
let tokenPromise: Promise<ITokenResults> | null = null;

const api = new ClientTokenService();

const get = async(): Promise<string | null> => {
  if (token === null) {
    await refresh();
  }

  return token;
};

const reset = () => {
  token = null;
  setTemporaryAccessToken(token);
};

const refresh = async (): Promise<void> => {
  if (tokenPromise === null) {
    tokenPromise = api.getToken();
  }

  const response = await tokenPromise;

  token = response.token ?? null;
  setTemporaryAccessToken(token);
  tokenPromise = null;
};

const clientTokenHelper = {
  reset,
  get
};

export default clientTokenHelper;
